$('.Popover__Value').click(function(){
	var sel = $(this).data('value');
    var presel = $.trim($('.ProductForm__SelectedValue').text());
  	
  	if(sel != presel){
  	  setTimeout(function() {
        newVariant();
      }, 300);
    }
  //setTimeout(function() { $('.ProductForm__AddToCart').hide(); }, 50);
    
});
function newVariant(){
    var variant = $('.main_select').val();
    var noimages = 0;
  
    $('.trigger-thumbs').each(function(){
      $('.trigger-thumbs').css({"opacity":0.4});
      $(this).removeClass('active-thumb');
      if($(this).data('variant-id') !=''){ noimages =1;}
    });
  
  if(noimages == 0){ return;}
      
    $('.'+variant).addClass('active-thumb');
    var image_id = $('.'+variant).attr("image-link");
    var varid = $('.'+variant).data('variant-id');
    var cur_pos = 100;
    var pos = parseInt($('.'+variant).attr("pos")) - 1;
    var x100 = pos*100;
    $('.flickity-page-dots .dot').each(function(){
      if ($(this).hasClass('is-selected')) {
        cur_pos =  parseInt($(this).index()) * 100;
      }
    });

    $('.flickity-page-dots .dot').removeClass('is-selected');
    $('.flickity-page-dots .dot').eq(pos).addClass('is-selected');

    //$('.Product__SlideshowNavDot').removeClass('is-selected');
    //$('.Product__SlideshowNavDot').eq(pos).addClass('is-selected');
    //$('.Product__SlideshowNavDot').eq(pos).trigger('click');

    $('.Product__SlideItem').removeClass('is-selected');
    $('#'+image_id).addClass('is-selected');
    $('.Product__SlideshowNavDot').removeClass('is-selected');

    $('#'+image_id).css({"left": x100+"%"});
    $('.flickity-slider').css({"transform": "translateX(-"+x100+"%)"});      

    $('.active-thumb').css({"opacity":1});
}